import { Colors } from '../../consts/Colors.js';
import { A2Data } from '../../consts/Data.js';
import Part1 from './Part1.js';
import Part2 from './Part2.js';
import Part3 from './Part3.js';

export default class A2ScreenManager extends Phaser.GameObjects.Container {
    constructor(scene, part) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;
        this.screensData = A2Data.screens
        this.part = part;
        this.activePart = null;
        this.setPart(this.part)

    }

    setPart(part) {
        if (part === 1) {
            this.part1 = new Part1(this.scene, this.screensData.part1, this);
            this.activePart = this.part1;
        } else if (part === 2) {
            this.part2 = new Part2(this.scene, this.screensData.part2, this);
            this.activePart = this.part2;
        } else if (part === 3) {
            this.part3 = new Part3(this.scene, this.screensData.part3, this);
            this.activePart = this.part3;
        }
        this.scene.menu.setMenuState(part, true);
    }

    changePart(part) {
        console.log("Change part to ", part);
        if(this.activePart.qcm && this.activePart.qcm.isFeedbackOn){
            this.activePart.qcm.feedback.screenContainer.destroy();
            this.activePart.qcm.validateBtn.destroy();
        }
        this.activePart?.destroy();
        this.setPart(part);
    }


}
